import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import NotificationConnectionKpi from '../../components/Notifications/NotificationConnectionKpi';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSave,
    faRotate,
    faCircleArrowLeft,
    faXmark,
    faEyeSlash,
    faEye
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";
import Loader from "../../components/Loader";

const UserElectronicSignature = ({ handleLogout }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const { gemaId } = location.state || {};
    const { ruc } = location.state || {};
    const { client } = location.state || {};
    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmarClave, setConfirmarClave] = useState("");
    const [flagActive, setCheckObservacion] = useState(true);
    const [gemaUserId, setGemaUserId] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mensaje, setMensaje] = useState(0);
    const [isSuccessNotifVisible, setIsSuccessNotifVisible] = useState(false);

    useEffect(() => {
        if (id) {
            const fetchProduct = async () => {
                try {
                    const response = await apiClient.get(`/gema/user/${id}`);
                    setUserName(response.data[0].userName);
                    setEmail(response.data[0].email);
                    setPassword(response.data[0].password);
                    setGemaUserId(response.data[0].gemaId);
                } catch (error) {
                    console.error("Error al cargar el Usuario", error);
                }
            };
            fetchProduct();
        }
    }, [id]);

    const toggleShowPassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };
    const handleClick = () => {
        navigate(-1);
    };

    const toggleShowPassword2 = () => {
        setShowPassword2((prevShowPassword) => !prevShowPassword);
    };

    const toggleSwitch = () => {
        setCheckObservacion((prev) => !prev);
    };
    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };


    const validateEmail = (email) => {
        // Expresión regular para validar el formato de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email); // Solo valida el formato del correo
    };
    const handleChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        // Validar el email
        if (!validateEmail(value)) {
            setErrors({
                email: 'Email inválido. Debe contener "@" y un dominio válido.',
            });
        } else {
            setErrors({});
        }
    };

    const validateFields = () => {
        let validationErrors = {};
        if (!email) validationErrors.email = "El Campo es Obligatorio";
        if (!password) validationErrors.password = "El Campo es Obligatorio";
        if (!confirmarClave) validationErrors.confirmarClave = "El Campo es Obligatorio";
        if (!userName) validationErrors.userName = "El Campo es Obligatorio";
        if (!password) validationErrors.password = "El Campo es Obligatorio";
        if (password !== confirmarClave) {
            validationErrors.confirmarClave = "Las claves no coinciden";
        }
        return validationErrors;
    };

    const isHandleCloseSuccess = () => {
        setIsSuccessNotifVisible(false);
        navigate(-1);
    };

    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            setLoading(true);
            let response;
            if (id) {
                const payloadUpdate = {
                    password,
                    flagActive
                };
                response = await apiClient.patch(`/gema/user/${gemaUserId}`, payloadUpdate);
                if (response.status === 200) {
                    const register = `RUC: ${ruc}
                        Razón Social: ${client}
                        Usuario: ${userName}
                        Contraseña: ${password}`;
                    setMensaje(register);
                    setIsSuccessNotifVisible(true);
                }
            } else {
                const payload = {
                    username: userName,
                    email,
                    password,
                    companyId: gemaId,
                    flagActive
                };
                response = await apiClient.post("/gema/user", payload);
                if (response.status === 201) {
                    const register = `RUC: ${ruc}
                        Razón Social: ${client}
                        Usuario: ${userName}
                        Contraseña: ${password}`;
                    setMensaje(register);
                    setIsSuccessNotifVisible(true);
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            } else if (error.response?.data?.message.startsWith("GEMA_COMPANY_NOT_FOUND")) {
                setMessageBlock(`El número de compania ingresado No existe.`)
                setNotificationBlock(true);

            } else if (error.response?.data?.message.startsWith("Username Already Exists")) {
                setMessageBlock(`El Usuario ingresado ya existe.`)
                setNotificationBlock(true);
            }
            else {
                setErrorMessage("Oops!. Ocurrio un error al crear el Usario");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Usuario de Firma Electrónica" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={handleClick}
                    />
                </div>
                <div className="info-section-container">
                    <label > CLIENTE: {client} |  RUC: {ruc}  </label>
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del Usuario de Firma Electrónica</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.userName ? "red" : "revert-layer" }}>
                            {" "}
                            Nombre de Usuario
                        </label>
                        <input
                            type="text"
                            placeholder="Nombre de Usuario"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            readOnly={!!id}
                        />
                        {errors.userName && <p className="error-message">{errors.userName}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.email ? "red" : "revert-layer" }}>
                            {" "}
                            Email
                        </label>
                        <input
                            type="text"
                            placeholder="Email"
                            value={email}
                            onChange={handleChange}
                            readOnly={!!id}
                        />
                        {errors.email && <p className="error-message">{errors.email}</p>}
                    </div>

                    <div className="basic-info-form-group">
                        <label style={{ color: errors.password ? "red" : "revert-layer" }}>
                            Clave
                        </label>
                        <div className="password-input-container">
                            <input
                                className="text-box-login2"
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Contraseña"
                            />
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                className="password-toggle-icon2"
                                onClick={toggleShowPassword}
                            />
                        </div>
                        {errors.password && <p className="error-message">{errors.password}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.confirmarClave ? "red" : "revert-layer" }}>
                            Confirmar Clave
                        </label>
                        <div className="password-input-container">
                            <input
                                className="text-box-login2"
                                type={showPassword2 ? "text" : "password"}
                                placeholder="Confirmar Clave"
                                value={confirmarClave}
                                onChange={(e) => setConfirmarClave(e.target.value)}
                            />
                            <FontAwesomeIcon
                                icon={showPassword2 ? faEyeSlash : faEye}
                                className="password-toggle-icon2"
                                onClick={toggleShowPassword2}
                            />
                        </div>
                        {errors.confirmarClave && <p className="error-message">{errors.confirmarClave}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <div className="basic-info-form-switch">
                            <label>Estado</label>
                            <div className="slider-container-contract" onClick={toggleSwitch}>
                                <div
                                    className={`slider-option-contract ${flagActive
                                        ? "active-contract"
                                        : "inactive-contract"
                                        }`}
                                >
                                    Activo
                                </div>
                                <div
                                    className={`slider-option-contract ${!flagActive
                                        ? "active-contract"
                                        : "inactive-contract"
                                        }`}
                                >
                                    Inactivo
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/UsersList");
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button
                        className="basic-custom-button"
                        onClick={handleSave}
                    >
                        <FontAwesomeIcon
                            icon={id ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {id ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            {loading && <Loader />}
            <SuccessNotification
                message={
                    id
                        ? "El Usuario se ha Actualizado Correctamente."
                        : "El Usuario se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorsMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuele a iniciar sesión"
                isVisible={isLoginVisible}
                onClose={() => setIsLoginVisible(false)}
                onLogout={handleLogout}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={`No se puede Crear el Usuario debido a : ${messageBlock}`}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={false}
                    whatsApp={false}
                />
            )}
            {isSuccessNotifVisible && (
                <NotificationConnectionKpi
                    message={`Los datos del Usuario GEMA son:`}
                    men1={mensaje}  // Pasando men1 como prop
                    isVisible={isSuccessNotifVisible}
                    onClose={isHandleCloseSuccess}
                    enca={id ? "Actualizado Correctamente" : false}
                />
            )}


        </div>
    );
};

export default UserElectronicSignature;
